import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, text, light = false, className = "" }) => (
  <div className={`max-w-2xl ${className}`}>
    {eyebrow && <p className={`eyebrow ${light ? "text-[#E8927F]" : ""}`}>{eyebrow}</p>}
    <h2 className={`mt-3 text-2xl font-bold sm:text-3xl lg:text-4xl ${light ? "text-white" : "text-slate-900"}`}>{title}</h2>
    {text && <p className={`mt-4 text-base leading-relaxed ${light ? "text-slate-300" : "text-slate-600"}`}>{text}</p>}
  </div>
);
